import { ItemKind } from "dto/IKindItems";

export const reverseKindItems = (kindNumber: number) => {
  const flags = {
    CourtPortalDeliverance: false,
    CourtPortalDocument: false,
    Parcel: false,
    EDeliveryMessage: false,
    NotaMessage: false,
    CourtPortalApplication: false,
    Email: false,
    ContactMessage: false,
    OutgoingParcel: false,
  };

  const toRet = kindNumber;

  if ((toRet & ItemKind.OutgoingParcel) !== 0) {
    flags.OutgoingParcel = true;
    flags.NotaMessage = true;
  }

  if ((toRet & ItemKind.CourtPortalApplication) !== 0) {
    flags.CourtPortalApplication = true;
  }

  if ((toRet & ItemKind.ContactMessage) !== 0) {
    flags.ContactMessage = true;
  }

  if ((toRet & ItemKind.Email) !== 0) {
    flags.Email = true;
  }

  if ((toRet & ItemKind.Parcel) !== 0) {
    flags.Parcel = true;
  }

  if ((toRet & ItemKind.CourtPortalDeliverance) !== 0) {
    flags.CourtPortalDeliverance = true;
  }

  if ((toRet & ItemKind.CourtPortalDocument) !== 0) {
    flags.CourtPortalDocument = true;
  }

  if ((toRet & ItemKind.EDeliveryMessage) !== 0) {
    flags.EDeliveryMessage = true;
  }

  return flags;
};
